import React from 'react'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {PriceWatchCTAWrapper} from 'components/PriceWatchCTAWrapper/PriceWatchCTAWrapper'
import {getAccommodationPageHotel} from 'modules/searchApi/selectors'

import {PriceWatchToggle} from '@vio/shared/src/priceWatch/components/PriceWatchToggle/PriceWatchToggle'

const COMPONENT_NAME = 'TopOffersPriceWatchToggle'

const BorderlessToggle = styled(PriceWatchToggle)`
  border: 0;
  padding: 0;
`

const CompactPriceWatchToggle: typeof PriceWatchToggle = props => (
  <BorderlessToggle {...props} />
)

export const TopOffersPriceWatchToggle = () => {
  const hotel = useSelector(getAccommodationPageHotel)

  return (
    <PriceWatchCTAWrapper
      hotel={hotel}
      ctaComponent={CompactPriceWatchToggle}
      componentName={COMPONENT_NAME}
      searchIsCompleted
      shouldPulse={false}
    />
  )
}
